import isInViewport from './isInViewport'

/**
 * Detects a click outside one or more elements.
 * @param {HTMLElement|HTMLElement[]} elements - The element(s) to detect clicks outside of.
 * @param {function} callback - The function to call when a click outside is detected.
 */
export default function clickOutside(elements, callback) {
  if (!elements || !callback) {
    console.warn('clickOutside: Missing element(s) or callback.')
    return
  }

  // Ensure elements is a NodeList or an array
  const elementList =
    elements instanceof NodeList ? Array.from(elements) : Array.isArray(elements) ? elements : [elements]

  function handleClickOutside(event) {
    let clickedInside = false
    for (const element of elementList) {
      if (element === event.target || element.contains(event.target)) {
        clickedInside = true
        break // Exit the loop if the click is inside any of the elements
      }
    }

    // Check if all elements are in viewport
    const allInViewport = elementList.every(el => isInViewport(el))

    if (!clickedInside && allInViewport) {
      callback(event, elementList) // Pass the array of elements to the callback
    }
  }

  document.body.addEventListener('click', handleClickOutside)

  // Return a function to remove the event listener
  return () => {
    document.body.removeEventListener('click', handleClickOutside)
  }
}

// Example usage:
// const removeClickListener = clickOutside([element1, element2], (event, elements) => {
//   console.log('Clicked outside the elements!', event, elements);
// });

// To remove the event listener later:
// removeClickListener();
